<template>
    <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="28.959" height="32" viewBox="0 0 28.959 32">
        <path d="M47.237,6.467H44.823v6.856h2.414ZM40.6,6.438H38.188V13.3H40.6ZM30.342,0,24.31,5.714V26.286h7.239V32l6.033-5.714h4.828L53.269,16V0ZM50.856,14.859l-4.826,4.57H41.2l-4.225,4v-4H31.549V2.286H50.856Z" transform="translate(-24.31)" class="fill-current" />
    </svg>
</template>